export const CONNECT4_RULES = [
  "Take turns dropping your coin into any available column.",
  "Coins fall to the lowest empty space in the selected column.",
  "Connect 4 of your coins in a row horizontally, vertically, or diagonally.",
  "Block your opponent from completing their line of 4.",
  "The first player to connect 4 coins wins!",
];
